import { render, staticRenderFns } from "./UlDialogChangePushFixed.vue?vue&type=template&id=ba8783fa&"
import script from "./UlDialogChangePushFixed.vue?vue&type=script&lang=ts&"
export * from "./UlDialogChangePushFixed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports